const baseStyle = {}

const defaultProps = {}

const parts: string[] = []

const sizes = {}

const variants = {}

export default {
  baseStyle,
  defaultProps,
  parts,
  sizes,
  variants,
}
